import { useTranslation } from 'react-i18next'

import {
  type KomaRange,
  groupContiguousKomaRanges,
} from '~/models/contiguousKomaRanges'

/**
 * GC 関連の chip (送る直前の除外 / 作成時のそろえ) の modal で、コマ番号列を
 * 「コマ 1〜3 (00:00〜01:30), コマ 5 (02:00〜02:30)」の形に整形する関数を返す。
 * 整形規則を 1 箇所に保つため、両 chip はこの hook を通す。
 */
export const useFormatKomaRanges = (): ((komas: number[]) => string) => {
  const { t } = useTranslation()
  const formatRange = (range: KomaRange): string => {
    const numberLabel =
      range.start === range.end
        ? `${range.start}`
        : `${range.start}〜${range.end}`
    return t('page:planSubmission.gcExcludedKoma.range', {
      range: numberLabel,
      time: range.timeLabel,
    })
  }
  return (komas) => groupContiguousKomaRanges(komas).map(formatRange).join(', ')
}
